module.exports = __webpack_public_path__ + "img/style_model_preview_673.bd730200.jpg";